import React from 'react';

import { Container } from './style';
import Step from './step';

import { ForniturePage, RecapPaymentPage } from '../../i18n';

export default ({ step = 0 }) => {
    if (step > 4) {
        step = 4;
    }

    return (
        <Container>
            <Step
                label="DATI PERSONALI"
                time="40 sec"
                show={step === 0}
                isCompleted={0 < step}
            />
            
            <Step
                label={ForniturePage.progressionRow.title}
                time={ForniturePage.progressionRow.time}
                show={step === 1}
                time="2 min"
                isCompleted={1 < step}
            />
            
            <Step
                label={RecapPaymentPage.progressionRow.title}
                time={RecapPaymentPage.progressionRow.time}
                show={step === 2}
                time="2 min"
                isCompleted={2 < step}
            />
            
            <Step
                label="Consensi"
                show={step === 3}
                time="1 min"
                isCompleted={3 < step}
            />
            
            <Step
                label="Riepilogo"
                show={step === 4}
                time="20 sec"
                isLast={true}
                isCompleted={4 < step}
            />

        </Container>
    )
}